import { z } from "zod"

const vehicleTypeValues = [
	"COMMISSION_CAR",
	"COMPANY_CAR",
	"CUSTOMER_REPLACEMENT_CAR",
	"DEMO_CAR",
	"NEW_CAR",
	"USED_CAR",
] as const

export const vehicleTypeSchema = z.enum(vehicleTypeValues)
export type VehicleType = z.infer<typeof vehicleTypeSchema>
